import { useState } from 'react';
import { useToggle } from 'react-use';

import useFetch from '../../hooks/useFetch';
import Api from '../../api';
import emailValidation from '../../utils/emailValidation';
import isEmpty from 'lodash/isEmpty';

const useForgotPassword = () => {
  const [email, setEmail] = useState(null);
  const [showInfo, toggle] = useToggle(false);
  const [state, setState] = useState({});
  const { data, onSubmit } = useFetch('forgot-password', Api.FORGOT_PASSWORD);

  const handleSubmit = (values) => {
    onSubmit({ body: values });
    toggle();
  };
  const onBlur = (e) => {
    const value = e.target.value;
    const isEmailValid = emailValidation(value);

    setState({
      isValid: isEmailValid,
      value,
    });
  };

  const showError = !isEmpty(state.value) && state.isValid === false;

  const handleSendAgain = () => onSubmit({ body: { email } });

  return {
    email,
    showInfo,
    data,
    showError,
    onSubmit: handleSubmit,
    onSendAgain: handleSendAgain,
    onBlur,
  };
};

export default useForgotPassword;
